module.exports = __webpack_public_path__ + "static/media/img_image.661f1b86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_image.png
// module id = 1009
// module chunks = 0